import * as React from 'react';

import moment from 'moment';

import {isToday, isYesterday} from 'nutshell-core/date-time';

import {FormattedTimestamp} from '../timestamp/formatted-timestamp';
import {Body} from '../typography/body';

type Props = {
    date: any;
};

export function TableDateTwoLine(props: Props) {
    const {date} = props;

    const momentDate = date && date > 0 ? moment.unix(date) : undefined;
    if (!momentDate) return null;

    let DateComponent;
    if (isToday(momentDate)) {
        DateComponent = 'Today';
    } else if (isYesterday(momentDate)) {
        DateComponent = 'Yesterday';
    } else {
        DateComponent = (
            <FormattedTimestamp datetime={date} format={FormattedTimestamp.formats.longMonthDay} />
        );
    }

    // @ts-expect-error
    const TimeComponent = <FormattedTimestamp datetime={date} format='h:mma' />;

    return (
        <div>
            <Body size='small' color='dark'>
                {DateComponent}
            </Body>
            <Body size='small' color='light'>
                {TimeComponent}
            </Body>
        </div>
    );
}
